import React, { FC } from 'react'
import block from 'bem-cn'

import { Icon } from 'components/UIKit/Icon'

import './HiddenControl.scss'

const b = block('input-hidden-control')

type Props = {
  isHidden?: boolean
  hasSuffix?: boolean
  hide: () => void
  reveal: () => void
}

export const HiddenControl: FC<Props> = ({ hasSuffix, isHidden, reveal, hide }) => (
  <button type="button" className={b({ hasSuffix })} onClick={isHidden ? reveal : hide}>
    <Icon type="Eye-off" className={b('icon', { hidden: isHidden })} size={20} />
    <Icon type="Eye-on" className={b('icon', { hidden: !isHidden })} size={20} />
  </button>
)
